import { CheckInCategory } from "types/globalTypes";

const MA_PAYER = "MA - Payer";
const MA_DSNP = "MA - DSNP";

// Program templates that do not incentivize medication reminder
const NON_INCENTIVIZED_MEDICATION = [MA_PAYER, MA_DSNP];

export const isMedicationReminder = (checkInCategory: CheckInCategory) =>
  checkInCategory === CheckInCategory.Medication;

export const isReminderIncentivized = (
  programTemplate: string,
  checkInCategory: CheckInCategory,
) => {
  // Medication is the only category that may not be incentivized
  if (isMedicationReminder(checkInCategory)) {
    return !NON_INCENTIVIZED_MEDICATION.includes(programTemplate);
  }
  return true;
};

// When a reminder's type is changed, adopt the program's seeded config value
// (wellth.reminder_config.is_required) for the new category — the DB is the
// source of truth for what each task type should be. One exception: Medication
// on templates that do not incentivize it (MA - Payer / MA - DSNP), where
// required medication is invalid by policy and clamps to false regardless of
// the seed. If the program has no config row for the new category, fall back
// to the template default.
export const getIsRequiredOnCategoryChange = (
  programTemplate: string,
  checkInCategory: CheckInCategory,
  configIsRequired?: boolean,
) => {
  if (
    isMedicationReminder(checkInCategory) &&
    !isReminderIncentivized(programTemplate, checkInCategory)
  ) {
    return false;
  }
  if (configIsRequired !== undefined) {
    return configIsRequired;
  }
  return isReminderIncentivized(programTemplate, checkInCategory);
};

export const isNiHStudyProgram = (programCode: string) =>
  programCode === "NIH-S-2025-WC";
